import { BuildRulesetQuery } from '../../../interfaces/Rulesets';
import { extractJsonFieldSql } from '../../extractJsonFieldSql';

export const selectFields_ruleset5_PD_6W: string = `
    CASE WHEN bestrank.rank is not null then 2 else 1 END as rank,
    id, data.label, attributes`;

export const order_ruleset5_PD_6W = 'rank DESC, data.label';

const getAttributes = (rawName: string) => ({
    flow1: `$.510.${rawName}`,
    flow2: `$.511.${rawName}`,
    dpmax: `$.28.${rawName}`,
    dn: `$.15.${rawName}`,
});


// 6-Way CCV

export const buildQuery_ruleset5_PD_6W: BuildRulesetQuery = ({
    selectFields,
    rawName,
    filter,
    volumetricFlow,
    volumetricFlow2,
    kvs,
    kvs2
}): [string, string[]] => {
    const attrs = getAttributes(rawName);
    return [
        `
WITH product_filtered as (SELECT 
                   ifnull(cast(attrs.value as float), 0)  as kvs1,
                   ifnull(cast(attrs2.value as float), 0) as kvs2,
                   coalesce(cast(dpmaxAttr.value as float), 0) as dpmax,
                   cast(dnAttr.value as float) as DN,
                   lineAttrs.value as line,
                   product.id,
                   label,
                   attributes
               FROM product
               LEFT JOIN json_each(${extractJsonFieldSql('attributes', `${attrs.dn}`)}) as dnAttr    
               LEFT JOIN json_each(${extractJsonFieldSql('attributes', attrs.flow1)}) as attrs
               LEFT JOIN json_each(${extractJsonFieldSql('attributes', attrs.flow2)}) as attrs2
               LEFT JOIN json_each(${extractJsonFieldSql('attributes', attrs.dpmax)}) as dpmaxAttr
               LEFT JOIN json_each(json_extract(attributes, '$.7266.${rawName}')) as lineAttrs
               WHERE ${filter}
               AND ${extractJsonFieldSql('attributes', `$.7266.${rawName}`)} in ('["6-way zone valve"]')
               )
         ,user_input1 as (SELECT cast(? as float) as kvs, cast(? as float) as v100_1)
         ,user_input2 as (SELECT cast(? as float) as kvs, cast(? as float) as v100_2)
         ,bounds as (SELECT
                cast(floor(user_input1.kvs * 0.6 * 10) as float) / 10 as lower1,
                cast(ceil(user_input1.kvs * 1.2 * 10) as float) / 10 as upper1, 
                cast(floor(user_input2.kvs * 0.6 * 10) as float) / 10 as lower2,
                cast(ceil(user_input2.kvs * 1.2 * 10) as float) / 10 as upper2,
                user_input1.kvs as kvs1,
                user_input2.kvs as kvs2,
                user_input1.v100_1 as v100_1,
                user_input2.v100_2 as v100_2
        FROM user_input1 JOIN user_input2)
   , data as (SELECT
                  DN,
                  ROUND(ABS(bounds.kvs1 - product_filtered.kvs1), 2) as rank1,
                  ROUND(ABS(bounds.kvs2 - product_filtered.kvs2), 2) as rank2,
                  *
              FROM product_filtered
              JOIN bounds
              WHERE
                  product_filtered.kvs1 between bounds.lower1 AND bounds.upper1
                AND product_filtered.kvs2 between bounds.lower2 AND bounds.upper2
                AND CASE WHEN dpmax > 0 THEN
                   dpmax >= max(
                    100 * pow(bounds.v100_1 / product_filtered.kvs1, 2),
                    100 * pow(bounds.v100_2 / product_filtered.kvs2, 2)
                   )
                ELSE true END
                AND CASE WHEN DN > 0 AND bounds.v100_1 > 0 AND bounds.v100_2 > 0 THEN
                  bounds.v100_1 / (3600 * pi() * pow(DN / 1000 / 2, 2)) <= 4
                  AND bounds.v100_2 / (3600 * pi() * pow(DN / 1000 / 2, 2)) <= 4
                ELSE true END
              )
   ,bestrank as (SELECT min(rank1 + rank2) as rank, line FROM data GROUP BY line)
SELECT ${selectFields}
FROM data
LEFT JOIN bestrank ON bestrank.rank = data.rank1 + data.rank2 AND bestrank.line = data.line
`,
        [kvs, volumetricFlow, kvs2, volumetricFlow2]
    ];
}
